import { render, staticRenderFns } from "./betDetailIframe.vue?vue&type=template&id=51cceb9e"
import script from "./betDetailIframe.vue?vue&type=script&lang=js"
export * from "./betDetailIframe.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/app.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51cceb9e')) {
      api.createRecord('51cceb9e', component.options)
    } else {
      api.reload('51cceb9e', component.options)
    }
    module.hot.accept("./betDetailIframe.vue?vue&type=template&id=51cceb9e", function () {
      api.rerender('51cceb9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/betDetailIframe.vue"
export default component.exports